import { render } from "./SwitchDark.vue?vue&type=template&id=c7891234"
import script from "./SwitchDark.vue?vue&type=script&lang=js"
export * from "./SwitchDark.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/frontdash/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__